import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'trending-down', 'TrendingDown', [["path",{"d":"M3 7l6 6l4 -4l8 8"}],["path",{"d":"M21 10l0 7l-7 0"}]]);